import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { BASE_URL } from "../env";
import styles from "../components/Coupons.module.css";
import style from "../Assets/css/profile.module.css";
import { Link } from "react-router-dom";

const Allcourses = () => {
	const [allcourses, setAllcourses] = useState([]);

	useEffect(() => {
		fetch(BASE_URL + "/smallCourses/getAllcourses", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((data) => {
				setAllcourses(data.data);
				console.log(data.data);
				// setdata(data)
				// console.log(data.data[0]);
				// setSection(data.data[0].videos)
				// setVideos(data.data[0].videos)
			});

		return () => {};
	}, []);
	function Addcourse(id) {
		console.log(id);
		fetch(BASE_URL + "/enroll/" + id, {
			headers: {
				authorization: "Bearer " + localStorage.getItem("token"),
			},
			method: "POST",
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				// console.log(data)
			});
	}
	return (
		<div>
			<Navbar />
			<div className="container-fluid bg-primary p-5 text-light">
				<h1>Courses that we are offering</h1>

				<div className="container">
					{allcourses.map((value, index) => {
						return (
							<>
								<div className="my-4">
									<div
										className={
											"card shadow row p-4 " +
											styles.gradient
										}
									>
										<div className="col">
											<span>
												<img
													src="https://files.codingninjas.in/0000000000003771.png"
													alt=""
												/>

												<span
													className={style.underline}
													style={{
														fontSize: "30px",
														marginLeft: "3%",
														fontFamily: "'DM Sans'",
														color: "black",
														lineHeight: "1px",
													}}
												>
													{value?.name}
													<div
														className={
															"" + styles.borders
														}
														style={{
															marginLeft: "12%",
														}}
													></div>
													{/* <hr style={{border:"4px solid #180ADB",width:"10%",marginLeft:"9%"}} /> */}
												</span>
											</span>
										</div>
										<div className="col">
											<br />
											<div className="d-flex flex-row justify-content-between my-3">
												<span
													className={
														styles.newfonts +
														" text-muted mx-5"
													}
													style={{
														fontFamily: "DM Sans",
														color: "grey",
													}}
												>
													Date Added
													<br />
													<span
														style={{
															fontFamily:
																"DM Sans",
															fontWeight: "500",
															color: "black",
														}}
													>
														21 Jul,2021
													</span>
												</span>
												<button
													onClick={() =>
														Addcourse(value._id)
													}
													className="btn btn-primary"
												>
													ENROLL COURSE
												</button>
											</div>
										</div>
									</div>
								</div>
							</>
						);
					})}
				</div>
			</div>

			<Footer />
		</div>
	);
};

export default Allcourses;
